import { resolveTypedMentions } from "../notes/mentions";
import type { AppUser } from "../../services/userService";

/**
 * Wer in einem Notiz-Abschnitt erwähnt ist — gelesen aus seinem HTML: die
 * @-Chips der Auswahl und von Hand getippte `@kürzel`.
 *
 * T-406 (User 27.10.2026): Das Notizfeld speichert schon in der Tipp-Pause.
 * Wer „@Sa“ tippt und kurz auf die Auswahl wartet, hat die Notiz damit schon
 * angelegt; die danach gewählte Person stand nirgends in `mentions`, und die
 * Mitteilung blieb aus. Deshalb zählt, was im Text steht — nicht nur, was in
 * der noch ungespeicherten Schreibstelle gewählt wurde.
 */
export function erwaehnteIn(html: string, users: AppUser[]): string[] {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const chips = Array.from(doc.querySelectorAll(".nb-mention"), (c) => c.textContent ?? "").join(" ");
    // Zeilen und Umbrüche trennen, sonst klebt „@SaH“ am nächsten Wort.
    for (const br of Array.from(doc.querySelectorAll("br"))) br.replaceWith("\n");
    const text = Array.from(doc.body.childNodes, (k) => k.textContent ?? "").join("\n");
    return vereinigeMentions(resolveTypedMentions(chips, users), resolveTypedMentions(text, users));
}

/**
 * Die seit dem letzten Speichern dazugekommenen Erwähnungen. Nur die zählen
 * beim Ändern einer Notiz: Wer eine alte Notiz korrigiert, soll nicht alle
 * darin Erwähnten noch einmal benachrichtigen.
 */
export function neuErwaehnt(vorher: string | undefined, jetzt: string, users: AppUser[]): string[] {
    const schon = new Set(vorher ? erwaehnteIn(vorher, users) : []);
    return erwaehnteIn(jetzt, users).filter((id) => !schon.has(id));
}

export function vereinigeMentions(...listen: ReadonlyArray<readonly string[] | undefined>): string[] {
    return Array.from(new Set(listen.flatMap((l) => l ?? [])));
}
